require('./Tasks.scss');

const React = require('react');
const {isNoteEquals} = require('stores/UserTaskStore');
const DateUtils = require('utils/DateUtils');
const {t} = require('services/i18nextWrapper');

const {
  Checkbox,
  FloatingActionButton,
  IconButton,
  TextField,
  DatePicker
} = require('material-ui');

const MAX_CHARACTER_ALLOWED = 200;

const Tasks = React.createClass({displayName: "Tasks",
  
  propTypes: {
    children: React.PropTypes.any,
    onClickClose: React.PropTypes.func,
    onChangeDate: React.PropTypes.func,
    isHidden: React.PropTypes.bool,
    date: React.PropTypes.string
  },
  
  componentDidUpdate(prevProps) {
    if (prevProps && this.props && prevProps.isHidden && !this.props.isHidden && this.props.onOpen) {
      this.props.onOpen(this.props.date);
    }
  },
  
  render() {
    const {children, onClickClose, isHidden, date, onChangeDate} = this.props;
    
    return (
      React.createElement("div", {className: `tasks${isHidden ? ' is-hidden' : ''}`}, 
        
        React.createElement("div", {className: "tasks__header"}, 
          React.createElement("div", {className: "tasks__header-date-picker"}, 
            React.createElement("h3", {className: "tasks__header-date-label"}, 
              t('dashboard_user_task_title')
            ), 
            React.createElement("div", {className: "tasks__header-date-value"}, 
              React.createElement(DatePicker, {
                textFieldStyle: {fontSize: '25px'}, 
                value: DateUtils.toDate(date), 
                defaultValue: DateUtils.toDate(date), 
                onChange: (_, date) => {
                  onChangeDate(DateUtils.toDateText(date));
                }, 
                hintText: "Inline", 
                container: "inline", 
                formatDate: DateUtils.toDisplayDateText}
              ), 
              React.createElement("div", {className: "tasks__header-date-icon"}, 
                React.createElement(IconButton, {iconClassName: "material-icons", tooltip: "GitHub"}, 
                  "edit_calendar"
                )
              )
            )
          ), 
          
          React.createElement("div", {className: "tasks__header-close"}, 
            React.createElement(FloatingActionButton, {
              onClick: onClickClose, 
              className: "tasks__header-close-btn", 
              iconClassName: "with-opacity muidocs-icon-action-grade", 
              backgroundColor: "gray"
            }, 
              React.createElement("i", {className: "material-icons md-16 btn-icon-center"}, "close")
            )
          )
        ), 
        
        React.createElement("div", {className: "tasks__container"}, 
          children
        ), 
        
        React.createElement("div", {className: "tasks__footer"}
        )
      )
    );
  }
});

const TaskList = React.createClass({displayName: "TaskList",
  render() {
    return (
      React.createElement("ul", {className: "task-list"}, 
        this.props.children
      )
    );
  }
});

TaskList.propTypes = {};

const TaskItem = React.createClass({displayName: "TaskItem",
  
  getInitialState() {
    return Object.assign({isEditMode: this.props.isEditMode},
      this.getDefaultState()
    );
  },
  
  getDefaultState() {
    return Object.assign({
      message: this.props.deleteDisabled ? '' : this.props.message,
      name: this.props.deleteDisabled ? '' : this.props.name,
      checked: this.props.deleteDisabled ? false : this.props.checked,
      errorMessage: ''
    });
  },
  
  propTypes: {
    message: React.PropTypes.string,
    name: React.PropTypes.string,
    checked: React.PropTypes.string,
    onSave: React.PropTypes.func,
    onDelete: React.PropTypes.func,
    onChange: React.PropTypes.func,
    isEditMode: React.PropTypes.bool,
    deleteDisabled: React.PropTypes.bool
  },
  
  onSaveHandler() {
    const {onSave} = this.props;
    const {message, name, checked} = this.state;
    if (!getMessageError(message)) {
      // it's not needed to check edition because we will save it.
      this.handlerChangeWithoutCheckEdition();
      onSave({note: message, name, checked});
      this.setState({isEditMode: false});
    }
  },
  
  /**
   * Horrible hack, because even after update state properly, material UI is not updating their internal state.
   */
  forceResetInputs() {
    this.getDOMNode().querySelector('.task-item__toggle input').checked = this.props.checked;
    this.getDOMNode().querySelector('.task-item__users input').value = this.props.name;
    this.getDOMNode().querySelector('.task-item__message input').value = this.props.message;
    this.handlerChange();
  },
  
  handlerChange() {
    this.setState({isEditMode: !isNoteEquals(this.props, this.state)});
    this.props.onChange(this.state);
  },
  
  handlerChangeWithoutCheckEdition() {
    this.props.onChange(this.state);
  },
  
  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isEditMode && this.state.isEditMode && this.state.isFocusMessage) {
      if (this._el) {
        this._el.getDOMNode().focus();
      }
    }
  },
  
  handlerReset() {
    const {name, message, checked} = this.props; // reset to default state
    this.setState({
      errorMessage: '',
      isEditMode: false, // say false because it was removed all changes
      name,
      message,
      checked,
      isFocusMessage: false
    }, this.forceResetInputs);
  },
  
  handlerKeyDown(evt) {
    const isKeyPressEnter = evt.keyCode === 13;
    const isKeyPressScape = evt.keyCode === 27;
    if (isKeyPressScape) this.handlerReset();
    if (isKeyPressEnter) this.onSaveHandler();
  },
  
  render() {
    const {onDelete, deleteDisabled} = this.props;
    const {isEditMode, message, name, checked, errorMessage} = this.state;
    const self = this;
    return (
      React.createElement("li", {className: "task-item"}, 
        React.createElement("div", {className: "task-item__toggle"}, 
          React.createElement(Checkbox, {
            defaultChecked: checked, 
            onCheck: evt => this.setState({checked: evt.target.checked}, this.handlerChange), 
            onKeyDown: this.handlerKeyDown}
          )
        ), 
        React.createElement("div", {className: "task-item__users"}, 
          React.createElement(TextField, {defaultValue: name || '', 
                     floatingLabelText: t('dashboard_user_task_task_item_label_name'), 
                     onChange: evt => this.setState({name: evt.target.value}, this.handlerChange), 
                     onKeyDown: this.handlerKeyDown, 
                     onBlur: () => this.setState({errorMessage: t(getMessageError(message))})}
          )
        ), 
        React.createElement("div", {className: "task-item__message"}, 
          
          React.createElement("div", {className: "task-item__message-input"}, 
            
            
              React.createElement(TextField, {
                floatingLabelText: t('dashboard_user_task_task_item_label_task'), 
                defaultValue: message, 
                errorText: errorMessage, 
                multiline: true, 
                ref: input => {
                  if (input) {
                    self._el = input;
                  }
                }, 
                onBlur: () => this.setState({errorMessage: t(getMessageError(message)), isFocusMessage: false}), 
                onChange: evt => this.setState({message: evt.target.value}, this.handlerChange), 
                onKeyDown: this.handlerKeyDown}
              )
            
          ), 
          
          React.createElement("div", {className: "task-item__actions"}, 
            isEditMode && !deleteDisabled &&
            React.createElement("div", {className: "task-item__actions task-item__actions-clear"}, 
              React.createElement(IconButton, {
                onClick: this.handlerReset, 
                iconClassName: "material-icons", 
                backgroundColor: "lightgray"}, 
                "clear"
              )
            ), 
            
            
            isEditMode &&
            React.createElement("div", {className: "task-item__actions task-item__actions-save"}, 
              React.createElement(IconButton, {
                iconClassName: "material-icons", 
                onClick: this.onSaveHandler, 
                backgroundColor: "lightgray"}, 
                "send"
              )
            )
            
          ), 
  
          !isEditMode && !deleteDisabled &&
          React.createElement("div", {className: "task-item__actions-remove"}, 
            React.createElement(IconButton, {
              iconClassName: "material-icons", 
              onClick: onDelete, 
              backgroundColor: "lightgray"}, 
              "delete"
            )
          )
          
        )
      
      )
    );
  }
});

function getMessageError(message) {
  const messageSafe = message || '';
  return messageSafe.length > MAX_CHARACTER_ALLOWED
    ? 'dashboard_user_task_inline_error_name_max_amount'
    : messageSafe.length === 0
      ? 'dashboard_user_task_inline_error_name'
      : '';
}

module.exports = {
  Tasks,
  TaskItem,
  TaskList
};


/** WEBPACK FOOTER **
 ** ./src/components/Tasks/Tasks.js
 **/